import { Group } from '../../models';

export interface IGroupTreeHelperService {
    getFlatChildren(groups: Group[], parentGuid: string): Group[];   
}

export class GroupTreeHelperService implements IGroupTreeHelperService {
    static serviceId = 'groupTreeHelperService';

    static $inject = [];

    getFlatChildren(groups: Group[], parentGuid: string, depth: number = 0): Group[] {
        let flatList = [];
        const children = groups.filter(g => g.parentGUID === parentGuid);
        if (children.length > 0) {
            depth++;
            children.forEach(child => {
                (child as any).depth = depth;
                flatList.push(child);
                const childs = this.getFlatChildren(groups, child.guid, depth);
                flatList = flatList.concat(childs);
            });
        }
        return flatList;
    }
}